export default {
  hasSideNav(state) {
    return state.hasSideNav;
  }
};
